<script>
	import { createEventDispatcher, afterUpdate } from "svelte";
	import { Portal } from "@xbs/svelte-wx";

	export let coords = { x: 0, y: 0 };
	export let wrapper = document.body;

	let self = null;

	const dispatch = createEventDispatcher();

	function fitToBody() {
		if (!self) return;

		const wrapperRect = wrapper.getBoundingClientRect();
		const popupRect = self.getBoundingClientRect();

		const dy = popupRect.bottom - wrapperRect.bottom;
		if (dy > 0) coords.y -= dy;

		const dx = popupRect.right - wrapperRect.right;
		if (dx > 0) coords.x -= dx;
	}

	function pointerDown(event) {
		if (!self.contains(event.target)) {
			dispatch("cancel", {
				event,
			});
		}
	}

	afterUpdate(fitToBody);

</script>

<svelte:window on:mousedown={pointerDown} />

<Portal theme="material">
	<div
		class="wx-todo_popup"
		style="left:{coords.x}px; top:{coords.y}px;"
		bind:this={self}>
		<slot />
	</div>
</Portal>

<style>
	.wx-todo_popup {
		position: absolute;
		z-index: 9999;

		background: var(--wx-background);
		box-shadow: var(--wx-box-shadow);
		border-radius: var(--wx-border-radius);
	}

</style>
